/* Maison Byōbu · la carte « 10 % de réduction contre l'e-mail », hors promotion (02/11/2026, décisions de Marcel du
   21/10 et du 30/10). Pendant une promotion datée, assets/mb-offre-popup.js garde la main : ce fichier ne fait rien,
   sauf définir window.mbInscrire, que les deux fichiers utilisent.
   - Ouverture seule : après 1 min 30 passée sur la page ET 30 % de la page défilée, une fois par semaine au plus,
     jamais au panier, au paiement ni au compte, jamais pendant une saisie ou par-dessus une autre fenêtre.
   - L'e-mail laissé : code posé sur le panier (/discount/…), puis inscription par window.mbInscrire, puis
     l'événement mb:bienvenue est émis (le panier se recharge).
   - 02/11 (audit P1-1) : l'inscription passait par un envoi direct en arrière-plan vers /contact, refusé par Shopify
     (400 « Missing CAPTCHA token ») : aucune cliente créée, aucun e-mail de bienvenue. Elle passe maintenant par un
     vrai formulaire client, envoyé par un clic : l'anti-robot de Shopify (hCaptcha) l'intercepte, ajoute son jeton,
     puis l'envoie vers un cadre caché (target), sans recharger la page : la cliente ne perd pas son mur en cours de
     composition. La réponse de Shopify ne s'affiche pas dans le cadre (frame-ancestors), c'est voulu : seul l'envoi
     compte. Vérification : la cliente apparaît dans Clients, étiquette bienvenue-popup.
   - 02/11, 20 h : sur le site en ligne, l'envoi partait parfois avant que Shopify ait posé l'anti-robot sur ce
     formulaire : sans jeton, Shopify renvoie vers sa page /challenge, invisible dans le cadre caché, et l'inscription
     était perdue. On attend maintenant le champ h-captcha-response du formulaire, puis 600 ms, avant d'envoyer.
     Testé dans Chrome sur le site en ligne : 2 inscriptions sur 2, cliente créée et abonnée en 2 s.
     (templates/page.mb-inscription.liquid et layout/mb-vide.liquid : premier essai, inutilisés, à supprimer.)
   - Panier : « Activer mes −10 % » ouvre la carte tant que l'e-mail n'a pas été laissé ; une fois l'e-mail laissé,
     le panier se recharge et affiche la remise (snippets/cart-summary.liquid fait le reste).
   - La phrase de la carte du panier reprend celle de la promotion Google (Marcel, 02/11).
   - 02/11, 19 h 25 : la frise de la fiche n'est plus modifiée ici (décision de Marcel : on n'y touche pas). */
(() => {
  if (window.mbInscrire) return;
  /* Inscrit l'adresse ; répond « envoye » (Shopify a reçu le formulaire), « erreur » ou « attente » (rien dans le
     délai : l'anti-robot peut encore aboutir si la page reste ouverte). Ne rejette jamais. */
  window.mbInscrire = (email, attente = 15000) => new Promise((resoudre) => {
    let fini = false;
    const noter = (etat) => { try { localStorage.setItem('mb_inscription', etat + ':' + Date.now()); } catch (x) {} };
    const finir = (etat) => { noter(etat); if (fini) return; fini = true; resoudre(etat); };
    try {
      const nom = 'mb-inscription-' + Date.now();
      const hors = 'position:fixed;left:-10000px;top:0;width:10px;height:10px;overflow:hidden;border:0;opacity:0;pointer-events:none';
      const cible = document.createElement('iframe');
      cible.name = nom;
      cible.title = 'Inscription';
      cible.tabIndex = -1;
      cible.setAttribute('aria-hidden', 'true');
      cible.style.cssText = hors;
      document.body.appendChild(cible);
      cible.addEventListener('load', () => finir('envoye'));
      const f = document.createElement('form');
      f.method = 'post';
      f.action = '/contact#mb-inscription';
      f.target = nom;
      f.acceptCharset = 'UTF-8';
      f.setAttribute('aria-hidden', 'true');
      f.style.cssText = hors;
      [['form_type', 'customer'], ['utf8', '✓'], ['contact[tags]', 'newsletter, invitations, bienvenue-popup']].forEach(([n, v]) => {
        const i = document.createElement('input');
        i.type = 'hidden'; i.name = n; i.value = v;
        f.appendChild(i);
      });
      const champ = document.createElement('input');
      champ.type = 'email'; champ.name = 'contact[email]'; champ.value = email; champ.tabIndex = -1;
      f.appendChild(champ);
      const bouton = document.createElement('button');
      bouton.type = 'submit'; bouton.tabIndex = -1;
      f.appendChild(bouton);
      document.body.appendChild(f);
      /* L'anti-robot de Shopify se charge quand un champ du formulaire reçoit le focus : on le signale sans donner
         le vrai focus (pas de clavier qui s'ouvre sur téléphone). */
      champ.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      champ.dispatchEvent(new FocusEvent('focus'));
      /* On attend que Shopify ait posé l'anti-robot sur CE formulaire (champ h-captcha-response), puis 600 ms, avant
         d'envoyer (8 s au plus : au-delà, on envoie quand même). */
      const debut = Date.now();
      const pret = () => !!(window.hcaptcha && f.querySelector('[name="h-captcha-response"]'));
      const envoyer = () => {
        if (!pret() && Date.now() - debut < 8000) { setTimeout(envoyer, 150); return; }
        setTimeout(() => bouton.click(), 600);
      };
      envoyer();
      setTimeout(() => finir('attente'), attente);
    } catch (x) { finir('erreur'); }
  });
  /* Pendant une promotion datée, la carte est gérée par assets/mb-offre-popup.js (envoi direct, refusé) : on inscrit
     l'adresse en parallèle, sans toucher à son déroulé. Hors promotion, le bloc suivant appelle mbInscrire lui-même. */
  document.addEventListener('submit', (e) => {
    const f = e.target && e.target.closest ? e.target.closest('[data-mb-bienvenue-form]') : null;
    if (!f || !(window.mbOffre && window.mbOffre.active && window.mbOffre.active())) return;
    const v = ((f.querySelector('input[type=email]') || {}).value || '').trim();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) window.mbInscrire(v);
  }, true);
})();
(() => {
  const racine = document.querySelector('[data-mb-offre]');
  if (!racine || racine.dataset.bienvenueActif !== 'true') return;
  if (window.mbOffre && window.mbOffre.active && window.mbOffre.active()) return;
  const dlg = document.querySelector('[data-mb-bienvenue]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  const code = racine.dataset.code || 'BIENVENUE10';
  const lire = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const ecrire = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };
  const aLeCode = () => lire('mb_bienvenue_code') === '1';
  const ouvrir = () => { if (!dlg.open) { dlg.showModal(); ecrire('mb_bienvenue_vu', String(Date.now())); } };
  const fermer = () => { if (dlg.open) dlg.close(); };

  /* Panier : la phrase, et le bouton qui demande l'e-mail (phase de capture : avant le script du panier) */
  const phrase = () => document.querySelectorAll('.mbp-cadeau__texte').forEach((p) => {
    if (/Profitez de/.test(p.textContent)) p.textContent = '10 % de réduction sur votre première commande.';
  });
  phrase();
  document.addEventListener('cart:update', () => setTimeout(phrase, 300));
  window.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mbp-activer]') || aLeCode()) return;
    e.preventDefault();
    e.stopPropagation();
    ouvrir();
  }, true);
  document.addEventListener('mb:bienvenue', () => {
    if (!document.querySelector('[data-mbp-cadeau]')) return;
    try { sessionStorage.setItem('mbp_cadeau', String(Date.now())); } catch (x) {}
    setTimeout(() => location.reload(), 900);
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mb-bienvenue-ouvrir]')) { e.preventDefault(); ouvrir(); }
    if (e.target.closest('[data-mb-bienvenue-fermer]')) fermer();
  });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) fermer(); });
  if (aLeCode()) { dlg.querySelector('[data-mb-bienvenue-form]').hidden = true; dlg.querySelector('[data-mb-bienvenue-code]').hidden = false; }

  /* Ouverture seule */
  const dejaVu = Number(lire('mb_bienvenue_vu') || 0);
  const pageCalme = !/^\/(cart|checkout|account)/.test(location.pathname);
  if (pageCalme && !aLeCode() && Date.now() - dejaVu > 7 * 864e5) {
    let fait = false;
    const occupe = () => {
      const a = document.activeElement;
      if (a && (a.matches('input, textarea, select, [contenteditable="true"]') || a.closest('[role="spinbutton"]'))) return true;
      if (document.querySelector('dialog[open]')) return true;
      return false;
    };
    const declencher = () => {
      if (fait) return;
      if (occupe()) { setTimeout(declencher, 3000); return; }
      fait = true; ouvrir();
    };
    const debut = Date.now();
    let defile = false;
    const essai = () => { if (defile && Date.now() - debut >= 90000) declencher(); };
    const surDefile = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      if (max > 0 && window.scrollY >= max * 0.3) { defile = true; removeEventListener('scroll', surDefile); essai(); }
    };
    addEventListener('scroll', surDefile, { passive: true });
    surDefile();
    setTimeout(essai, 90000);
  }

  /* L'e-mail laissé */
  const form = dlg.querySelector('[data-mb-bienvenue-form]');
  if (!form) return;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const champ = form.querySelector('input[type=email]');
    const err = form.querySelector('[data-mb-bienvenue-erreur]');
    const email = champ.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.hidden = false; champ.focus(); return; }
    err.hidden = true;
    try { await fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }); } catch (x) {}
    ecrire('mb_bienvenue_code', '1');
    form.hidden = true;
    dlg.querySelector('[data-mb-bienvenue-code]').hidden = false;
    if (window.mbInscrire) await window.mbInscrire(email);
    document.dispatchEvent(new CustomEvent('mb:bienvenue'));
  });
})();
/* 02/11 (audit P1-3 et P2) : le panier.
   - Sous 190 €, le cadeau de bienvenue ne disparaît plus sans un mot : une carte sobre dit ce qu'il manque.
     Mêmes conditions que snippets/cart-summary.liquid (au moins un papier peint, aucune autre remise que
     ECHANTILLON5), lues dans /cart.js.
   - Le montant annoncé avant activation est arrondi vers le bas, comme Shopify (352,98 € → −35,29 €, pas −35,30 €). */
(() => {
  if (!/^\/cart/.test(location.pathname)) return;
  const PICTO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7c-1.6-3.2-5.4-3.6-5.4-1.4C6.6 7 9.6 7 12 7zM12 7c1.6-3.2 5.4-3.6 5.4-1.4C17.4 7 14.4 7 12 7z"/></svg>';
  const SEUIL = 19000;
  const euros = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100);
  const poser = async () => {
    let c;
    try { c = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()); } catch (x) { return; }
    const badge = document.querySelector('[data-mbp-cadeau="disponible"] .mbp-cadeau__badge');
    if (badge) badge.textContent = '−' + euros(Math.floor(c.items_subtotal_price / 10));
    document.querySelectorAll('[data-mbp-cadeau="seuil-js"]').forEach((el) => el.remove());
    const murs = (c.items || []).filter((i) => i.product_type === 'Papier peint panoramique' && i.handle !== 'echantillon').length;
    const autre = (c.cart_level_discount_applications || []).some((a) => String(a.title || '').toUpperCase() !== 'ECHANTILLON5' && a.total_allocated_amount > 0)
      || (c.items || []).some((i) => (i.line_level_discount_allocations || []).some((a) => a.amount > 0));
    const base = c.items_subtotal_price;
    if (!murs || autre || base <= 0 || base >= SEUIL || document.querySelector('[data-mbp-cadeau]')) return;
    const zone = document.querySelector('cart-discount-component');
    if (!zone) return;
    const carte = document.createElement('div');
    carte.className = 'mbp-cadeau mbp-cadeau--sobre';
    carte.dataset.mbpCadeau = 'seuil-js';
    carte.innerHTML = '<div class="mbp-cadeau__tete"><span class="mbp-cadeau__picto">' + PICTO + '</span>'
      + '<p class="mbp-cadeau__titre">Votre cadeau de bienvenue</p></div>'
      + '<p class="mbp-cadeau__texte">−10 % sur votre première commande, dès 190 € d’achat. Il vous manque ' + euros(SEUIL - base) + '.</p>';
    zone.prepend(carte);
  };
  const lancer = () => { poser(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer); else lancer();
  document.addEventListener('cart:update', () => setTimeout(lancer, 500));
})();
